"use strict";

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.array.index-of");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.filter");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.map");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.object.define-property");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Particles = void 0;

var Particle_1 = require("./Particle");

var Utils_1 = require("../Utils");

var InteractionManager_1 = require("./Particle/InteractionManager");

var Particles = /*#__PURE__*/function () {
  function Particles(container) {
    _classCallCheck(this, Particles);

    this.container = container;
    this.array = [];
    this.interactionManager = new InteractionManager_1.InteractionManager(container);
    var canvasSize = this.container.canvas.size;
    this.linksColors = new Map();
    this.quadTree = new Utils_1.QuadTree(new Utils_1.Rectangle(0, 0, canvasSize.width, canvasSize.height), 4);
  }

  _createClass(Particles, [{
    key: "init",
    value: function init() {
      var container = this.container;
      var options = container.options;
      var handled = false;

      var _iterator = _createForOfIteratorHelper(container.plugins),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              plugin = _step$value[1];

          if (plugin.particlesInitialization !== undefined) {
            handled = plugin.particlesInitialization();
          }

          if (handled) {
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (!handled) {
        for (var i = this.count; i < options.particles.number.value; i++) {
          this.addParticle();
        }
      }

      if (options.infection.enable) {
        for (var _i = 0; _i < options.infection.infections; _i++) {
          var notInfected = this.array.map(function (p) {
            return p.infecter;
          }).filter(function (p) {
            return p.infectionStage === undefined;
          });
          var infected = Utils_1.Utils.itemFromArray(notInfected);
          infected.startInfection(0);
        }
      }

      this.interactionManager.init();
      container.noise.init();
    }
  }, {
    key: "redraw",
    value: function redraw() {
      this.clear();
      this.init();
      this.draw({
        value: 0,
        factor: 0
      });
    }
  }, {
    key: "removeAt",
    value: function removeAt(index, quantity) {
      if (index >= 0 && index <= this.count) {
        var _iterator2 = _createForOfIteratorHelper(this.array.splice(index, quantity !== null && quantity !== void 0 ? quantity : 1)),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var particle = _step2.value;
            particle.destroy();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  }, {
    key: "remove",
    value: function remove(particle) {
      this.removeAt(this.array.indexOf(particle));
    }
  }, {
    key: "update",
    value: function update(delta) {
      var container = this.container;
      var particlesToDelete = [];
      container.noise.update();

      var _iterator3 = _createForOfIteratorHelper(this.array),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _particle = _step3.value;

          _particle.move(delta);

          if (_particle.destroyed) {
            particlesToDelete.push(_particle);
            continue;
          }

          this.quadTree.insert(new Utils_1.Point(_particle.getPosition(), _particle));
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      for (var _i2 = 0, _particlesToDelete = particlesToDelete; _i2 < _particlesToDelete.length; _i2++) {
        var particle = _particlesToDelete[_i2];
        this.remove(particle);
      }

      this.interactionManager.externalInteract(delta);

      var _iterator4 = _createForOfIteratorHelper(this.container.particles.array),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _particle2 = _step4.value;

          _particle2.update(delta);

          this.interactionManager.particlesInteract(_particle2, delta);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "draw",
    value: function draw(delta) {
      var container = this.container;
      container.canvas.clear();
      var canvasSize = this.container.canvas.size;
      this.quadTree = new Utils_1.QuadTree(new Utils_1.Rectangle(0, 0, canvasSize.width, canvasSize.height), 4);
      this.update(delta);

      var _iterator5 = _createForOfIteratorHelper(container.plugins),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _step5$value = _slicedToArray(_step5.value, 2),
              plugin = _step5$value[1];

          container.canvas.drawPlugin(plugin, delta);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      var _iterator6 = _createForOfIteratorHelper(this.array),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var p = _step6.value;
          p.draw(delta);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.array = [];
    }
  }, {
    key: "push",
    value: function push(nb, mouse, overrideOptions) {
      var container = this.container;
      var options = container.options;
      var limit = options.particles.number.limit * container.density;
      this.pushing = true;

      if (limit > 0) {
        var countToRemove = this.count + nb - limit;

        if (countToRemove > 0) {
          this.removeQuantity(countToRemove);
        }
      }

      for (var i = 0; i < nb; i++) {
        this.addParticle(mouse === null || mouse === void 0 ? void 0 : mouse.position, overrideOptions);
      }

      if (!options.particles.move.enable) {
        this.container.play();
      }

      this.pushing = false;
    }
  }, {
    key: "addParticle",
    value: function addParticle(position, overrideOptions) {
      try {
        var particle = new Particle_1.Particle(this.container, position, overrideOptions);
        this.array.push(particle);
        return particle;
      } catch (_a) {
        console.log("error adding particle");
        return;
      }
    }
  }, {
    key: "removeQuantity",
    value: function removeQuantity(quantity) {
      var options = this.container.options;
      this.removeAt(0, quantity);

      if (!options.particles.move.enable) {
        this.container.play();
      }
    }
  }, {
    key: "count",
    get: function get() {
      return this.array.length;
    }
  }]);

  return Particles;
}();

exports.Particles = Particles;